// Display formatting shared by the lists.

/**
 * An Israeli phone number in local format: "+972501234567" / "0501234567" → "050-1234567", landlines
 * "+97231234567" → "03-1234567". Anything else is returned as it came.
 */
export const formatIsraeliPhone = (phone) => {
  if (!phone) {
    return '';
  }
  const raw = String(phone).trim();
  let digits = raw.replace(/\D/g, '');
  if (digits.startsWith('972')) {
    digits = `0${digits.slice(3)}`;
  }
  if (/^05\d{8}$/.test(digits) || /^07\d{8}$/.test(digits)) {
    return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  }
  if (/^0[2-489]\d{7}$/.test(digits)) {
    return `${digits.slice(0, 2)}-${digits.slice(2)}`;
  }
  return raw;
};
